import { FunctionComponent, useState, useEffect, useRef } from 'react'
import { FormControl, IconButton, InputLabel, OutlinedInput, Stack } from '@mui/material';
import { HighlightOff, SaveOutlined } from '@mui/icons-material';
import { IFuelEnergyContentFactorImportLine } from '../../../shared/services/fuel-energy-content-factor-import-line/fuel-energy-content-factor-import-line.model';

export const SuperAdminEnergyConversionFormField: FunctionComponent<{
  fuel: IFuelEnergyContentFactorImportLine,
  submitHandler: (id: string, fuelType: string, kwhKg?: number, kwhL?: number) => void,
}> = ({
  fuel,
  submitHandler,
}) => {
    const [kwhKg, setKwhKg] = useState<number | undefined>(undefined);
    const [kwhL, setKwhL] = useState<number | undefined>(undefined);
    const originalKwhKg = useRef<number | undefined>(undefined);
    const originalKwhL = useRef<number | undefined>(undefined);

    useEffect(() => {
      const initialKg = fuel?.kwhKg;
      const initialL = fuel?.kwhL;
      setKwhKg(initialKg);
      setKwhL(initialL);
      originalKwhKg.current = initialKg;
      originalKwhL.current = initialL;
    }, [fuel]);

    const saveHandler = () => {
      submitHandler(fuel.id, fuel.fuelType, kwhKg, kwhL);
    }

    const cancelHandler = () => {
      setKwhKg(originalKwhKg.current);
      setKwhL(originalKwhL.current);
    }

    return (
      <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
          <InputLabel htmlFor={`fuel-type-${fuel.id}`}>Fuel Type</InputLabel>
          <OutlinedInput
            id={`fuel-type-${fuel.id}`}
            name={`fuel-type-${fuel.id}`}
            label='Fuel Type'
            value={fuel.fuelType}
            disabled={true}
            type='text'
            sx={{ color: 'text.primary' }} />
        </FormControl>
        < FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
          <InputLabel htmlFor={`gross-cv-kwh-kg-${fuel.id}`}> Gross CV kWh/kg </InputLabel>
          < OutlinedInput
            id={`gross-cv-kwh-kg-${fuel.id}`}
            name={`gross-cv-kwh-kg-${fuel.id}`}
            label='Gross CV kWh/kg'
            value={kwhKg !== undefined ? kwhKg : ''}
            onChange={(e) => setKwhKg(e.target.value ? parseFloat(e.target.value) : undefined)}
            type='number'
            sx={{ color: 'text.primary' }} />
        </FormControl>
        < FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
          <InputLabel htmlFor={`gross-cv-kwh-l-${fuel.id}`}> Gross CV kWh/L </InputLabel>
          < OutlinedInput
            id={`gross-cv-kwh-l-${fuel.id}`}
            name={`gross-cv-kwh-l-${fuel.id}`}
            label='Gross CV kWh/L'
            value={kwhL !== undefined ? kwhL : ''}
            onChange={(e) => setKwhL(e.target.value ? parseFloat(e.target.value) : undefined)}
            type='number'
            sx={{ color: 'text.primary' }} />
        </FormControl>
        <IconButton sx={{ mt: 2 }} onClick={cancelHandler}>
          <HighlightOff />
        </IconButton>
        <IconButton sx={{ mt: 2 }} onClick={saveHandler}>
          <SaveOutlined />
        </IconButton>
      </Stack>
    )
  }